export const SET_TASK = 'CHANGE_STATUS/SET_TASK'
export const SET_TASKS = 'CHANGE_STATUS/SET_TASKS'
export const SET_CONTACTS = 'CHANGE_STATUS/SET_CONTACTS'
